import type { TFontsTypes } from '../../modal/models';

export const fontsTypes: TFontsTypes = {
    s: 'small',
    m: 'small',
    l: 'medium',
    xl: 'medium',
    fullscreen: 'medium',
};
